// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 60,
  type: "image_with_text",
  name: "Image with Text",
  category: "Storytelling",
  description: "Editorial storytelling section with image, copy, and call to action",
  defaultSettings: {
    title: "Crafted With Intention",
    subtitle: "SUSTAINABLE QUALITY",
    description: "Every item in our collection is curated with mindful craft and uncompromising standards. Discover essentials designed to endure.",
    buttonText: "Our Story",
    buttonLink: "/about",
    imagePosition: "left",
    imageUrl: "",
    backgroundColor: "#f9fafb",
  },
  fields: [
    { key: "subtitle", label: "Eyebrow / Subtitle", type: "text" },
    { key: "title", label: "Heading", type: "text" },
    { key: "description", label: "Paragraph Copy", type: "textarea" },
    { key: "buttonText", label: "Button Label", type: "text" },
    { key: "buttonLink", label: "Button Link", type: "text" },
    {
      key: "imagePosition",
      label: "Image Position",
      type: "select",
      options: [
        { value: "left", label: "Image on Left" },
        { value: "right", label: "Image on Right" },
      ],
    },
    { key: "imageUrl", label: "Feature Image", type: "image" },
    { key: "backgroundColor", label: "Section Background Color", type: "color" },
  ],
};

export default definition;
